import { apiClient } from "@/lib/apiClient";
import {
  normalizeBusyBlock,
  type BusyBlock,
  type ExternalBusyBlockDTO,
} from "@/lib/calendar/externalBusy";

/**
 * A master's busy time held outside Boona (her Google Calendar, another calendar app, Booksy) for
 * the given salon-local days — GET /api/v1/company/timetable/external_busy, authorised and
 * revalidated (ETag/304) like attendance_day. A master's login gets her own blocks; owners and
 * admins get every master's. A day outside her journal scope comes back empty.
 */
export async function fetchExternalBusy(dates: string[]): Promise<BusyBlock[]> {
  const days = Array.from(new Set(dates.filter(Boolean)));
  if (days.length === 0) return [];
  const params = days.map((d) => `dates%5B%5D=${encodeURIComponent(d)}`).join("&");
  const { data } = await apiClient.get(`/api/v1/company/timetable/external_busy?${params}`);
  const raw: ExternalBusyBlockDTO[] = Array.isArray(data?.blocks) ? data.blocks : [];
  return raw.map(normalizeBusyBlock).filter((block): block is BusyBlock => block !== null);
}
